<template>
  <div class="tile is-parent is-12 is-vertical">
    <article class="tile is-child">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">Faceoffs - Team vs Team</h1>
        <article class="is-child box">
          <h1 class="subtitle">Filters</h1>
          <div class="columns">
            <div class="column is-2">
            <div class="field is-horizontal">
              <label class="label">Period</label>
              <div class="control">
                <div class="select is-small">
                  <select v-model="PeriodSelected"  @change="fetchFaceoffs">
                    <option v-for="option in PeriodOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            </div>
            <div class="column is-2">
              <div class="field is-horizontal">
                <div class="control">
                  <label class="label">Situation</label>
                    <div class="control">
                      <div class="select is-small">
                        <select v-model="SituationSelected"  @change="fetchFaceoffs">
                          <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                        </select>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="column is-2">
              <div class="field is-horizontal">
                <div class="control">
                  <label class="label">Home Player</label>
                    <div class="control">
                      <div class="select is-small">
                        <select v-model="HomeSelection" @change="fetchFaceoffs">
                          <option v-for="option in HomeTeamOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                        </select>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="column is-2">
              <div class="field is-horizontal">
                <div class="control">
                  <label class="label">Away Player</label>
                    <div class="control">
                      <div class="select is-small">
                        <select v-model="AwaySelection" @change="fetchFaceoffs">
                          <option v-for="option in AwayTeamOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                        </select>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="column is-2">
              <div class="field is-horizontal">
                <div class="control">
                  <label class="label">Percentages?</label>
                    <div class="control">
                      <input type="checkbox" class="checkbox" v-model="usePercentage" @change="renderCharts">
                    </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <button class="button is-small is-info" @click="show = !show">Show / Hide</button>
        <div v-if="show">
              <canvas id="map" ref="map" class="fo_vs" width="1000" height="431"></canvas>
        </div>
        </div>
    </article>
  </div>
</template>
<script>
import Chart from 'vue-bulma-chartjs'
export default {
  props: ['defaultShow', 'home_name', 'away_name'],
  components: {
    Chart
  },
  data: function () {
    return {
      show: true,
      gameId: 1,
      SituationOptions: [],
      PeriodOptions: [],
      PeriodSelected: 0,
      SituationSelected: 0,
      FaceoffsData: [],
      HomePlayers: [],
      AwayPlayers: [],
      HomeTeamOptions: [],
      HomeSelection: 0,
      AwayTeamOptions: [],
      AwaySelection: 0,
      usePercentage: false
    }
  },
  computed: {
    sortHomePlayers: function () {
      return this.HomePlayers.slice().sort(function (a, b) {
        return (a.number - b.number)
      })
    },
    sortAwayPlayers: function () {
      return this.AwayPlayers.slice().sort(function (a, b) {
        return (a.number - b.number)
      })
    }
  },
  methods: {
    fetchFaceoffs () {
      var canvas = this.$refs.map
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      let postData = {
        'id': this.gameId,
        'period': this.PeriodSelected,
        'situation': this.SituationSelected,
        'home_player': this.HomeSelection,
        'away_player': this.AwaySelection
      }
      this.$http
        .post(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/faceoff-vs/', postData,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.FaceoffsData = response.data.faceoff_vs[0]
            // console.log('FO DATA: ' + JSON.stringify(this.FaceoffsData) + this.FaceoffsData.offensive_left)
            this.renderCharts()
          },
          response => {}
        )
    },
    fetchPlayers () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/faceoffs/' + this.gameId, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
          response => {
            // console.log(JSON.stringify(response.data))
            this.HomePlayers = response.data.home_players
            this.AwayPlayers = response.data.away_players
            // console.log(JSON.stringify(this.HomePlayers))
            this.HomeTeamOptions.push({text: 'All', value: 0})
            this.AwayTeamOptions.push({text: 'All', value: 0})

            this.HomeTeamOptions.push({text: 'Forwards', value: 0})
            for (var i of this.sortHomePlayers) {
              if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
                if (i.number > 0) {
                  this.HomeTeamOptions.push({text: i.number + ' ' + i.surname, value: i.id})
                }
              }
            }
            this.HomeTeamOptions.push({text: 'Defense', value: -7})
            for (var d of this.sortHomePlayers) {
              if (d.position === 'LD' || d.position === 'RD') {
                this.HomeTeamOptions.push({text: d.number + ' ' + d.surname, value: d.id})
              }
            }
            this.AwayTeamOptions.push({text: 'Forwards', value: -2})
            for (var af of this.sortAwayPlayers) {
              if (af.position === 'LW' || af.position === 'C' || af.position === 'RW') {
                if (af.number > 0) {
                  this.AwayTeamOptions.push({text: af.number + ' ' + af.surname, value: af.id})
                }
              }
            }
            this.AwayTeamOptions.push({text: 'Defense', value: -3})
            for (var ad of this.sortAwayPlayers) {
              if (ad.position === 'LD' || ad.position === 'RD') {
                this.AwayTeamOptions.push({text: ad.number + ' ' + ad.surname, value: ad.id})
              }
            }
          })
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
          response => {
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: 'Even Handed', value: 1})
            this.SituationOptions.push({text: 'Power Play', value: 2})
            this.SituationOptions.push({text: 'Short Handed', value: 3})
            this.SituationOptions.push({text: 'Empty Net', value: 4})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})
          }
        )
    },
    renderCharts () {
      // console.log('Render Charts')
      var canvas = this.$refs.map
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      var colorList = ['#15607a', '#6bcab6']
      if (this.usePercentage) {
        // Top Left
        // console.log('FacoffData: ' + this.FaceoffsData.offensive_left_percentage)
        this.pie(ctx, 346, 160, 23, [this.FaceoffsData.offensive_right_percentage, 100 - this.FaceoffsData.offensive_right_percentage], colorList, 2.5, 'white')
        // Bottom Left
        this.pie(ctx, 346, 160, 240, [this.FaceoffsData.offensive_left_percentage, 100 - this.FaceoffsData.offensive_left_percentage], colorList, 2.5, 'white')
        // Top Right
        this.pie(ctx, 1660, 160, 23, [this.FaceoffsData.defensive_right_percentage, 100 - this.FaceoffsData.defensive_right_percentage], colorList, 2.5, 'white')
        // Bottom Right
        this.pie(ctx, 1660, 160, 240, [this.FaceoffsData.defensive_left_percentage, 100 - this.FaceoffsData.defensive_left_percentage], colorList, 2.5, 'white')
        // Neutral Top Left
        this.pie(ctx, 800, 60, 60, [this.FaceoffsData.neutral_offensive_right_percentage, 100 - this.FaceoffsData.neutral_offensive_right_percentage], colorList, 1.5, 'white')
        // Neutral Bottom Left
        this.pie(ctx, 800, 60, 290, [this.FaceoffsData.neutral_offensive_left_percentage, 100 - this.FaceoffsData.neutral_offensive_left_percentage], colorList, 1.5, 'white')
        // Neutral Top Right
        this.pie(ctx, 1210, 60, 60, [this.FaceoffsData.neutral_defensive_right_percentage, 100 - this.FaceoffsData.neutral_defensive_right_percentage], colorList, 1.5, 'white')
        // Neutral Bottom Right
        this.pie(ctx, 1210, 60, 290, [this.FaceoffsData.neutral_defensive_left_percentage, 100 - this.FaceoffsData.neutral_defensive_left_percentage], colorList, 1.5, 'white')
        // Center
        this.pie(ctx, 1002, 161, 130, [this.FaceoffsData.center_percentage, 100 - this.FaceoffsData.center_percentage], colorList, 2, 'white')
      } else {
        // console.log('FacoffData: ' + this.FaceoffsData.offensive_left_taken + '/' + this.FaceoffsData.offensive_left_w)
        this.pie(ctx, 346, 160, 23, [this.FaceoffsData.offensive_right_percentage, 100 - this.FaceoffsData.offensive_right_percentage], colorList, 2.5, 'white', this.FaceoffsData.offensive_right_taken, this.FaceoffsData.offensive_right_w)
        // Bottom Left
        this.pie(ctx, 346, 160, 240, [this.FaceoffsData.offensive_left_percentage, 100 - this.FaceoffsData.offensive_left_percentage], colorList, 2.5, 'white', this.FaceoffsData.offensive_left_taken, this.FaceoffsData.offensive_left_w)
        // Top Right
        this.pie(ctx, 1660, 160, 23, [this.FaceoffsData.defensive_right_percentage, 100 - this.FaceoffsData.defensive_right_percentage], colorList, 2.5, 'white', this.FaceoffsData.defensive_right_taken, this.FaceoffsData.defensive_right_w)
        // Bottom Right
        this.pie(ctx, 1660, 160, 240, [this.FaceoffsData.defensive_left_percentage, 100 - this.FaceoffsData.defensive_left_percentage], colorList, 2.5, 'white', this.FaceoffsData.defensive_left_taken, this.FaceoffsData.defensive_left_w)
        // Neutral Top Left
        this.pie(ctx, 800, 60, 60, [this.FaceoffsData.neutral_offensive_right_percentage, 100 - this.FaceoffsData.neutral_offensive_right_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_offensive_right_taken, this.FaceoffsData.neutral_offensive_right_w)
        // Neutral Bottom Left
        this.pie(ctx, 800, 60, 290, [this.FaceoffsData.neutral_offensive_left_percentage, 100 - this.FaceoffsData.neutral_offensive_left_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_offensive_left_taken, this.FaceoffsData.neutral_offensive_left_w)
        // Neutral Top Right
        this.pie(ctx, 1210, 60, 60, [this.FaceoffsData.neutral_defensive_right_percentage, 100 - this.FaceoffsData.neutral_defensive_right_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_defensive_right_taken, this.FaceoffsData.neutral_defensive_right_w)
        // Neutral Bottom Right
        this.pie(ctx, 1210, 60, 290, [this.FaceoffsData.neutral_defensive_left_percentage, 100 - this.FaceoffsData.neutral_defensive_left_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_defensive_left_taken, this.FaceoffsData.neutral_defensive_left_w)
        // Center
        this.pie(ctx, 1002, 161, 130, [this.FaceoffsData.center_percentage, 100 - this.FaceoffsData.center_percentage], colorList, 2, 'white', this.FaceoffsData.center_taken, this.FaceoffsData.center_w)
      }
      this.drawText(ctx, this.home_name, [600, 40], '30px', '#15607a')
      this.drawText(ctx, this.away_name, [350, 40], '30px', '#6bcab6')
    },
    calculateDegrees (percent) {
      return percent / 100 * 360
    },
    drawCircle (ctx, color, position, radius, lineWidth = 2) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.lineWidth = lineWidth
      ctx.arc(position[0], position[1], radius, 0, 2 * Math.PI)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    },
    drawSector (ctx, color, position, radius, start, amount) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.lineWidth = 2
      ctx.arc(position[0], position[1], radius, 0, this.toRadians(amount))
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    },
    toRadians (degrees) {
      return degrees * Math.PI / 180
    },
    pie (ctx, w, h, yOffset, datalist, colorList, textSize, textColor, foTaken = 0, foWin = 0) {
      var radius = h / 2 - 2
      var centerx = w / 2
      var centery = h / 2 + yOffset
      var total = 0
      var labelxy = []

      for (var y = 0; y < datalist.length; y++) {
        total += datalist[y]
      }
      var lastend = 0
      var offset = Math.PI / 2
      for (var x = 0; x < datalist.length; x++) {
        var thispart = datalist[x]
        ctx.beginPath()
        ctx.fillStyle = colorList[x]
        ctx.moveTo(centerx, centery)
        var arcsector = Math.PI * (2 * thispart / total)
        ctx.arc(centerx, centery, radius, lastend - offset, lastend + arcsector - offset, false)
        ctx.lineTo(centerx, centery)
        ctx.fill()
        ctx.closePath()
        if (thispart > (total / 20)) {
          labelxy.push(lastend + arcsector / 2 + Math.PI + offset)
        }
        lastend += arcsector
      }
      var lradius = radius * 3 / 5
      ctx.strokeStyle = textColor
      ctx.fillStyle = textColor
      for (var i = 0; i < labelxy.length; i++) {
        var fontSize = lradius / textSize
        ctx.textAlign = 'center'
        ctx.font = fontSize + 'px sans-serif'
        var langle = labelxy[i]
        var dx = centerx + lradius * Math.cos(langle)
        var dy = centery + lradius * Math.sin(langle)
        if (this.usePercentage) {
          ctx.fillText(datalist[i] + '%', dx, dy)
        } else {
         // console.log('DX: ' + lradius)
          if (i % 2 === 0) {
            ctx.fillText(foWin + '/' + foTaken, dx, dy)
          } else {
            ctx.fillText(foTaken - foWin + '/' + foTaken, dx, dy)
          }
        }
      }
    },
    drawText (ctx, text, textPosition, textSize = '26px', color = 'white') {
      ctx.beginPath()
      ctx.font = textSize + ' sans-serif'
      ctx.fillStyle = color
      ctx.fillText(text, textPosition[0], textPosition[1])
      ctx.closePath()
    }
  },
  mounted () {
    if (this.defaultShow) {
      this.show = true
    }
    this.gameId = this.$route.params.gameId
    this.fetchFaceoffs()
    this.fetchPlayers()
    this.fetchFilterOptions()
  }
}
</script>
<style>
.table__wrapper {
  overflow-x: auto;
}
.fo_vs {
  background: url('~assets/NHLRink.svg');
}
</style>



// WEBPACK FOOTER //
// faceoff-team-vs.vue?bb2cdaf4